import { either, pipe } from '@code-expert/prelude';
/**
 * Guard a render tree from rendering unless we have a right either
 */
export const GuardEither = ({ value, render, alt = () => null, }) => pipe(value, either.fold(alt, render));
//# sourceMappingURL=GuardEither.js.map